"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Field = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importStar(require("react"));
const formik_1 = require("formik");
const index_1 = require("./../index");
const styled_components_1 = __importDefault(require("styled-components"));
const Label_1 = require("./Label");
const _1 = require(".");
const FieldError_1 = require("./FieldError");
const react_i18next_1 = require("react-i18next");
const InputWithInvalidStyle = (0, styled_components_1.default)(index_1.Input) `
  ${(props) => (0, _1.getInvalidStyle)(props.invalid, props.theme.error)}
`;
const Unit = styled_components_1.default.div `
  position: relative;
  top: -23px;
  right: 36px;
  height: 0;
  text-align: right;
`;
const Field = (props) => {
    var _a;
    const { t } = (0, react_i18next_1.useTranslation)("central-web-app-components");
    const [field, meta] = (0, formik_1.useField)(props);
    const [fieldsToShowPassword, setFieldsToShowPassword] = (0, react_1.useState)(false);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Label_1.MultiLineLabel, { ...props }),
        react_1.default.createElement(index_1.Flex, { col: true, noWrap: true },
            react_1.default.createElement("div", { style: { display: "inline-block", position: "relative" } },
                react_1.default.createElement(InputWithInvalidStyle, { ...props, ...field, disabled: props.disabled, invalid: meta.touched && meta.error !== undefined, id: props.name, "data-testid": `input-${props.name}`, type: props.type === "password" && fieldsToShowPassword
                        ? "text"
                        : props.type, value: props.hideFieldValue ? "" : field.value, placeholder: props.hideFieldValue
                        ? props.conditionalPlaceholder
                        : props.placeholder }),
                react_1.default.createElement(index_1.Flex, { style: { position: "absolute", padding: "7px", top: 0, right: 0 } }, props.type === "password" && ((_a = props.passwordReveal) !== null && _a !== void 0 ? _a : true) ? (react_1.default.createElement(index_1.Flex, { style: { cursor: "pointer" }, onClick: () => setFieldsToShowPassword(!fieldsToShowPassword) }, fieldsToShowPassword ? (react_1.default.createElement(index_1.Invisible, { fill: "gray", name: t `tooltip-Hidepassword` })) : (react_1.default.createElement(index_1.Visible, { fill: "gray", name: t `tooltip-Showpassword` })))) : null)),
            props.unit ? react_1.default.createElement(Unit, null, props.unit) : ""),
        meta.touched && meta.error && (react_1.default.createElement(FieldError_1.FieldError, { "data-testid": `${props.name}Error` }, meta.error))));
};
exports.Field = Field;
//# sourceMappingURL=Field.js.map